import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { auth } from '../firebase/firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import {
  FaBars,
  FaTimes,
  FaSignOutAlt,
  FaHome,
  FaMapMarkerAlt,
  FaBook,
  FaSitemap,
  FaUserCheck,
  FaCalendarAlt
} from 'react-icons/fa';
import { GiCampingTent } from 'react-icons/gi';
import './NavBar.css';
import logo from '../assets/logo.png';

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [user] = useAuthState(auth);
  const navigate = useNavigate();

  const handleLogout = () => {
    auth.signOut();
    navigate('/');
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <header className="navbar">
      <div className="navbar-logo">
        <Link to="/dashboard" className="navbar-logo-link" onClick={closeMenu}>
          {logo && <img src={logo} alt="App Logo" className="app-logo" />}
          <span className="app-name">Sirius Dashboard</span>
        </Link>
      </div>
      <button
        className="burger-icon"
        onClick={toggleMenu}
        aria-label="Menü umschalten"
        aria-controls="primary-navigation"
        aria-expanded={isOpen}
      >
        {isOpen ? <FaTimes className="nav-icon" /> : <FaBars className="nav-icon" />}
      </button>

      {/* Desktop-Links */}
      <ul className="desktop-links">
        <li>
          <Link to="/dashboard" onClick={closeMenu}>
            <FaHome className="nav-icon" /> Dashboard
          </Link>
        </li>
        <li>
          <Link to="/links" onClick={closeMenu}>
            <FaSitemap className="nav-icon" /> Toolbox
          </Link>
        </li>
        <li>
          <Link to="/wiki" onClick={closeMenu}>
            <FaBook className="nav-icon" /> Wiki
          </Link>
        </li>
        <li>
          <Link to="/calendar" onClick={closeMenu}>
            <FaCalendarAlt className="nav-icon" /> Kalender
          </Link>
        </li>
        <li>
          <Link to="/lagerplatzverzeichnis" onClick={closeMenu}>
            <FaMapMarkerAlt className="nav-icon" /> Lagerplatz
          </Link>
        </li>
        {false && (
          <li>
            <Link to="/lager-admin" onClick={closeMenu}>
              <GiCampingTent className="nav-icon" /> LagerAdmin
            </Link>
          </li>
        )}
        {user && (
          <li className="navbar-user">
            <span className="username">{user.displayName || user.email}</span>
          </li>
        )}
        {user && (
          <li>
            <button onClick={handleLogout} className="logout-button">
              <FaSignOutAlt className="nav-icon" /> Abmelden
            </button>
          </li>
        )}
      </ul>

      {/* Mobiles Menü */}
      <div
        className={`mobile-menu-overlay ${isOpen ? 'open' : ''}`}
        onClick={(e) => {
          if (e.target.classList.contains('mobile-menu-overlay')) {
            closeMenu();
          }
        }}
      >
        <nav
          id="primary-navigation"
          className={`mobile-menu ${isOpen ? 'open' : ''}`}
          aria-hidden={!isOpen}
        >
          <ul>
            <li>
              <Link to="/dashboard" onClick={closeMenu}>
                <FaHome className="nav-icon" /> Dashboard
              </Link>
            </li>
            <li>
              <Link to="/links" onClick={closeMenu}>
                <FaSitemap className="nav-icon" /> Toolbox
              </Link>
            </li>
            <li>
              <Link to="/wiki" onClick={closeMenu}>
                <FaBook className="nav-icon" /> Wiki
              </Link>
            </li>
            <li>
              <Link to="/calendar" onClick={closeMenu}>
                <FaCalendarAlt className="nav-icon" /> Kalender
              </Link>
            </li>
            <li>
              <Link to="/AnAbmeldungen" onClick={closeMenu}>
                <FaUserCheck className="nav-icon" /> An/Abmeldungen
              </Link>
            </li>
            <li>
              <Link to="/lagerplatzverzeichnis" onClick={closeMenu}>
                <FaMapMarkerAlt className="nav-icon" /> Lagerplatzverzeichnis
              </Link>
            </li>
            {false && (
              <li>
                <Link to="/lager-admin" onClick={closeMenu}>
                  <GiCampingTent className="nav-icon" /> LagerAdmin
                </Link>
              </li>
            )}
            {user && (
              <li className="navbar-user mobile-user-info">
                <span className="username">{user.displayName || user.email}</span>
                <button onClick={handleLogout} className="logout-button mobile-logout">
                  <FaSignOutAlt className="nav-icon" /> Abmelden
                </button>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default NavBar;